import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import _ from 'lodash';
import { environment } from 'src/environments/environment';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { RouterOutlet } from '@angular/router';
import { NoInternetComponent } from './public/views/errors/no-internet/no-internet.component';
import { UpdateService } from './core/updates/update-app.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
    imports: [
        NoInternetComponent,
        RouterOutlet,
    ],
})
export class AppComponent implements OnInit {
    title = 'devolsoft-mes';
    previousCon = true;
    showNoInternetScreen: boolean = false;
    environment: any;

    constructor(
        private updateService: UpdateService, // It is necessary to import this service for the update service to be initialized
        private connectionService: ConnectionService,
        private cdRef: ChangeDetectorRef
    ) {
        this.environment = _.cloneDeep(environment);
        this.connectionService
            .monitor()
            .subscribe((connectionState: ConnectionState) => {
                const isConnected = connectionState.hasNetworkConnection;
                this.showNoInternetScreen = this.previousCon && !isConnected;
                this.previousCon = isConnected;
            });
    }

    ngOnInit(): void {
        this.cdRef.detectChanges();
    }
}
